module.exports = __webpack_public_path__ + "img/linkedin-black.5b3f7a10.svg";